import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Given a list of dispensary slugs, fetch cached Google Places ratings
 * in a single batch call. Returns `{ [slug]: { rating, rating_count } }`
 * or an empty object while loading / on error. Never blocks the render —
 * card shows the rating chip when data arrives, otherwise nothing.
 */
export function useShopRatings(slugs) {
  const [ratings, setRatings] = useState({});

  useEffect(() => {
    if (!slugs || !slugs.length) {
      setRatings({});
      return;
    }
    const key = slugs.slice().sort().join(",");
    let cancelled = false;
    api
      .get(`/dispensaries/ratings/batch?slugs=${encodeURIComponent(key)}`)
      .then((r) => {
        if (!cancelled) setRatings(r.data?.ratings || {});
      })
      .catch(() => {
        if (!cancelled) setRatings({});
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugs?.length, (slugs || []).slice().sort().join(",")]);

  return ratings;
}
